import UltMeta, { Meta } from "./UltMeta/index";

// 留言反馈定义

/**
 * 留言类型
 */
class Type extends UltMeta {
    /** 意见建议 */
    SUGGESTION = new Meta(1, "意见建议");
    /** 功能问题 */
    FUNCTIONAL_ISSUE = new Meta(2, "功能问题");
    /** 平台规则 */
    PLATFORM_RULE = new Meta(3, "平台规则");
    /** 投诉 */
    COMPLAINT = new Meta(4, "投诉");
    /** 其他 */
    OTHER = new Meta(5, "其他");
}
/** 留言类型 */
export const MESSAGE_FEEDBACK_TYPE = new Type();

/**
 * 留言状态
 */
class State extends UltMeta {
    /** 待回复 */
    WAITING = new Meta(0, "待回复");
    /** 已回复 */
    REPLIED = new Meta(1, "已回复");
}
/** 留言状态 */
export const MESSAGE_FEEDBACK_STATE = new State();
